<template>
  <div class="home">
    <domain-component></domain-component>

    <changelog-component v-if="signedIn"></changelog-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DomainComponent from "@/components/DomainComponent";
import ChangelogComponent from "@/components/ChangelogComponent";

export default {
  components: {
    DomainComponent,
    ChangelogComponent,
  },

  computed: {
    ...mapGetters({ signedIn: "user/signedIn" }),
  },
};
</script>
